const models = [
  {
    make: "Acura",
    name: "vehicle_make_acura",
    label: "Vehicle Make Acura",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "RLX",
        value: "rlx",
      },
      {
        label: "TLX",
        value: "tlx",
      },
      {
        label: "MDX",
        value: "mdx",
      },
      {
        label: "RDX",
        value: "rdx",
      },
      {
        label: "MDX Sport Hybrid",
        value: "mdx_sport_hybrid",
      },
      {
        label: "RLX Sport Hybrid",
        value: "rlx_sport_hybrid",
      },
    ],
  },
  {
    make: "Alfa Romeo",
    name: "vehicle_make_alfa_romeo",
    label: "Vehicle Make Alfa Romeo",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "4C Spider",
        value: "4c_spider",
      },
      {
        label: "Stelvio",
        value: "stelvio",
      },
      {
        label: "Giulia",
        value: "giulia",
      },
      {
        label: "4C",
        value: "4c",
      },
      {
        label: "164",
        value: "164",
      },
      {
        label: "Spider",
        value: "spider",
      },
    ],
  },
  {
    make: "Aston Martin",
    name: "vehicle_make_aston_martin",
    label: "Vehicle Make Aston Martin",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Vanquish S",
        value: "vanquish_s",
      },
      {
        label: "DB11",
        value: "db11",
      },
      {
        label: "Rapide S",
        value: "rapide_s",
      },
      {
        label: "Vanquish",
        value: "vanquish",
      },
      {
        label: "Vantage",
        value: "vantage",
      },
      {
        label: "DB9 GT",
        value: "db9_gt",
      },
      {
        label: "DB9",
        value: "db9",
      },
      {
        label: "Rapide",
        value: "rapide",
      },
      {
        label: "DBS",
        value: "dbs",
      },
      {
        label: "Virage",
        value: "virage",
      },
    ],
  },
  {
    make: "Audi",
    name: "vehicle_make_audi",
    label: "Vehicle Make Audi",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Q2",
        value: "q2",
      },
      {
        label: "Q3",
        value: "q3",
      },
      {
        label: "SQ5",
        value: "sq5",
      },
      {
        label: "R8",
        value: "r8",
      },
      {
        label: "R8 V10",
        value: "r8_v10",
      },
      {
        label: "Q5",
        value: "q5",
      },
      {
        label: "A7",
        value: "a7",
      },
      {
        label: "A6",
        value: "a6",
      },
      {
        label: "A4",
        value: "a4",
      },
      {
        label: "Q7",
        value: "q7",
      },
      {
        label: "Q8",
        value: "q8",
      },
      {
        label: "RS 5",
        value: "rs_5",
      },
      {
        label: "A8",
        value: "a8",
      },
      {
        label: "A3",
        value: "a3",
      },
      {
        label: "S5",
        value: "s5",
      },
      {
        label: "A4 allroad",
        value: "a4_allroad",
      },
      {
        label: "e-tron",
        value: "e_tron",
      },
      {
        label: "RS 3",
        value: "rs_3",
      },
      {
        label: "A5",
        value: "a5",
      },
      {
        label: "S3",
        value: "s3",
      },
      {
        label: "S4",
        value: "s4",
      },
      {
        label: "TT",
        value: "tt",
      },
      {
        label: "A3 Sportback e-tron",
        value: "a3_sportback_e_tron",
      },
      {
        label: "S7",
        value: "s7",
      },
      {
        label: "S6",
        value: "s6",
      },
      {
        label: "S8",
        value: "s8",
      },
      {
        label: "RS 7",
        value: "rs_7",
      },
      {
        label: "A5 Sport",
        value: "a5_sport",
      },
      {
        label: "allroad",
        value: "allroad",
      },
      {
        label: "RS 4",
        value: "rs_4",
      },
      {
        label: "A4 (2005.5)",
        value: "a4_(2005.5)",
      },
      {
        label: "S4 (2005.5)",
        value: "s4_(2005.5)",
      },
      {
        label: "RS 6",
        value: "rs_6",
      },
      {
        label: "Cabriolet",
        value: "cabriolet",
      },
      {
        label: "90",
        value: "90",
      },
      {
        label: "Quattro",
        value: "quattro",
      },
      {
        label: "100",
        value: "100",
      },
      {
        label: "80",
        value: "80",
      },
      {
        label: "A6 allroad",
        value: "a6_allroad",
      },
    ],
  },
  {
    make: "Bentley",
    name: "vehicle_make_bentley",
    label: "Vehicle Make Bentley",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Bentayga",
        value: "bentayga",
      },
      {
        label: "Flying Spur",
        value: "flying_spur",
      },
      {
        label: "Continental",
        value: "continental",
      },
      {
        label: "Mulsanne",
        value: "mulsanne",
      },
      {
        label: "Azure T",
        value: "azure_t",
      },
      {
        label: "Brooklands",
        value: "brooklands",
      },
      {
        label: "Arnage",
        value: "arnage",
      },
      {
        label: "Azure",
        value: "azure",
      },
    ],
  },
  {
    make: "BMW",
    name: "vehicle_make_bmw",
    label: "Vehicle Make BMW",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "3 Series",
        value: "3_series",
      },
      {
        label: "X3",
        value: "x3",
      },
      {
        label: "7 Series",
        value: "7_series",
      },
      {
        label: "X7",
        value: "x7",
      },
      {
        label: "X5",
        value: "x5",
      },
      {
        label: "4 Series",
        value: "4_series",
      },
      {
        label: "2 Series",
        value: "2_series",
      },
      {
        label: "5 Series",
        value: "5_series",
      },
      {
        label: "M5",
        value: "m5",
      },
      {
        label: "i8",
        value: "i8",
      },
      {
        label: "8 Series",
        value: "8_series",
      },
      {
        label: "M6",
        value: "m6",
      },
      {
        label: "i3",
        value: "i3",
      },
      {
        label: "6 Series",
        value: "6_series",
      },
      {
        label: "M4",
        value: "m4",
      },
      {
        label: "X6 M",
        value: "x6_m",
      },
      {
        label: "X2",
        value: "x2",
      },
      {
        label: "X1",
        value: "x1",
      },
      {
        label: "X6",
        value: "x6",
      },
      {
        label: "X4",
        value: "x4",
      },
      {
        label: "M2",
        value: "m2",
      },
      {
        label: "Z4",
        value: "z4",
      },
      {
        label: "M3",
        value: "m3",
      },
      {
        label: "X5 M",
        value: "x5_m",
      },
      {
        label: "1 Series",
        value: "1_series",
      },
      {
        label: "Z4 M",
        value: "z4_m",
      },
      {
        label: "Alpina B7",
        value: "alpina_b7",
      },
      {
        label: "Z8",
        value: "z8",
      },
      {
        label: "Z3",
        value: "z3",
      },
      {
        label: "M",
        value: "m",
      },
    ],
  },
  {
    make: "Buick",
    name: "vehicle_make_buick",
    label: "Vehicle Make Buick",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Envision",
        value: "envision",
      },
      {
        label: "Encore",
        value: "encore",
      },
      {
        label: "Enclave",
        value: "enclave",
      },
      {
        label: "Regal Sportback",
        value: "regal_sportback",
      },
      {
        label: "Regal TourX",
        value: "regal_tourx",
      },
      {
        label: "Cascada",
        value: "cascada",
      },
      {
        label: "LaCrosse",
        value: "lacrosse",
      },
      {
        label: "Regal",
        value: "regal",
      },
      {
        label: "Verano",
        value: "verano",
      },
      {
        label: "Lucerne",
        value: "lucerne",
      },
      {
        label: "Rendezvous",
        value: "rendezvous",
      },
      {
        label: "Terraza",
        value: "terraza",
      },
      {
        label: "Rainier",
        value: "rainier",
      },
      {
        label: "Century",
        value: "century",
      },
      {
        label: "Park Avenue",
        value: "park_avenue",
      },
      {
        label: "LeSabre",
        value: "lesabre",
      },
      {
        label: "Riviera",
        value: "riviera",
      },
      {
        label: "Skylark",
        value: "skylark",
      },
      {
        label: "Roadmaster",
        value: "roadmaster",
      },
      {
        label: "Encore GX",
        value: "encore_gx",
      },
    ],
  },
  {
    make: "Cadillac",
    name: "vehicle_make_cadillac",
    label: "Vehicle Make Cadillac",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Escalade ESV",
        value: "escalade_esv",
      },
      {
        label: "XT6",
        value: "xt6",
      },
      {
        label: "XT5",
        value: "xt5",
      },
      {
        label: "XT4",
        value: "xt4",
      },
      {
        label: "CT6-V",
        value: "ct6_v",
      },
      {
        label: "Escalade",
        value: "escalade",
      },
      {
        label: "CT5",
        value: "ct5",
      },
      {
        label: "CTS-V",
        value: "cts_v",
      },
      {
        label: "CT6",
        value: "ct6",
      },
      {
        label: "CTS",
        value: "cts",
      },
      {
        label: "XTS",
        value: "xts",
      },
      {
        label: "ATS-V",
        value: "ats_v",
      },
      {
        label: "ATS",
        value: "ats",
      },
      {
        label: "ELR",
        value: "elr",
      },
      {
        label: "SRX",
        value: "srx",
      },
      {
        label: "Escalade EXT",
        value: "escalade_ext",
      },
      {
        label: "DTS",
        value: "dts",
      },
      {
        label: "STS",
        value: "sts",
      },
      {
        label: "XLR",
        value: "xlr",
      },
      {
        label: "DeVille",
        value: "deville",
      },
      {
        label: "Seville",
        value: "seville",
      },
      {
        label: "Eldorado",
        value: "eldorado",
      },
      {
        label: "Catera",
        value: "catera",
      },
      {
        label: "Fleetwood",
        value: "fleetwood",
      },
      {
        label: "Allante",
        value: "allante",
      },
      {
        label: "Sixty Special",
        value: "sixty_special",
      },
      {
        label: "Brougham",
        value: "brougham",
      },
      {
        label: "CT4",
        value: "ct4",
      },
    ],
  },
  {
    make: "Chevrolet",
    name: "vehicle_make_chevrolet",
    label: "Vehicle Make Chevrolet",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Malibu",
        value: "malibu",
      },
      {
        label: "Corvette",
        value: "corvette",
      },
      {
        label: "Silverado 2500 HD Crew Cab",
        value: "silverado_2500_hd_crew_cab",
      },
      {
        label: "Colorado Crew Cab",
        value: "colorado_crew_cab",
      },
      {
        label: "Silverado 3500 HD Crew Cab",
        value: "silverado_3500_hd_crew_cab",
      },
      {
        label: "Traverse",
        value: "traverse",
      },
      {
        label: "Camaro",
        value: "camaro",
      },
      {
        label: "Equinox",
        value: "equinox",
      },
      {
        label: "Blazer",
        value: "blazer",
      },
      {
        label: "Suburban",
        value: "suburban",
      },
      {
        label: "Spark",
        value: "spark",
      },
      {
        label: "Silverado 1500 Crew Cab",
        value: "silverado_1500_crew_cab",
      },
      {
        label: "Bolt EV",
        value: "bolt_ev",
      },
      {
        label: "Tahoe",
        value: "tahoe",
      },
      {
        label: "Impala",
        value: "impala",
      },
      {
        label: "Trax",
        value: "trax",
      },
      {
        label: "Cruze",
        value: "cruze",
      },
      {
        label: "Express 2500 Cargo",
        value: "express_2500_cargo",
      },
      {
        label: "Colorado Extended Cab",
        value: "colorado_extended_cab",
      },
      {
        label: "Express 2500 Passenger",
        value: "express_2500_passenger",
      },
      {
        label: "Express 3500 Passenger",
        value: "express_3500_passenger",
      },
      {
        label: "Silverado 2500 HD Double Cab",
        value: "silverado_2500_hd_double_cab",
      },
      {
        label: "Silverado 1500 Regular Cab",
        value: "silverado_1500_regular_cab",
      },
      {
        label: "Express 3500 Cargo",
        value: "express_3500_cargo",
      },
      {
        label: "Silverado 1500 LD Double Cab",
        value: "silverado_1500_ld_double_cab",
      },
      {
        label: "Silverado 2500 HD Regular Cab",
        value: "silverado_2500_hd_regular_cab",
      },
      {
        label: "Silverado 1500 Double Cab",
        value: "silverado_1500_double_cab",
      },
      {
        label: "Sonic",
        value: "sonic",
      },
      {
        label: "Volt",
        value: "volt",
      },
      {
        label: "Suburban 3500HD",
        value: "suburban_3500hd",
      },
      {
        label: "City Express",
        value: "city_express",
      },
      {
        label: "Silverado 3500 HD Double Cab",
        value: "silverado_3500_hd_double_cab",
      },
      {
        label: "Silverado 3500 HD Regular Cab",
        value: "silverado_3500_hd_regular_cab",
      },
      {
        label: "SS",
        value: "ss",
      },
      {
        label: "Cruze Limited",
        value: "cruze_limited",
      },
      {
        label: "Impala Limited",
        value: "impala_limited",
      },
      {
        label: "Malibu Limited",
        value: "malibu_limited",
      },
      {
        label: "Spark EV",
        value: "spark_ev",
      },
      {
        label: "Captiva Sport",
        value: "captiva_sport",
      },
      {
        label: "Express 1500 Cargo",
        value: "express_1500_cargo",
      },
      {
        label: "Express 1500 Passenger",
        value: "express_1500_passenger",
      },
      {
        label: "Suburban 1500",
        value: "suburban_1500",
      },
      {
        label: "Avalanche",
        value: "avalanche",
      },
      {
        label: "Silverado 2500 HD Extended Cab",
        value: "silverado_2500_hd_extended_cab",
      },
      {
        label: "Silverado 3500 HD Extended Cab",
        value: "silverado_3500_hd_extended_cab",
      },
      {
        label: "Silverado 1500 Extended Cab",
        value: "silverado_1500_extended_cab",
      },
      {
        label: "Suburban 2500",
        value: "suburban_2500",
      },
      {
        label: "Colorado Regular Cab",
        value: "colorado_regular_cab",
      },
      {
        label: "Aveo",
        value: "aveo",
      },
      {
        label: "HHR",
        value: "hhr",
      },
      {
        label: "Cobalt",
        value: "cobalt",
      },
      {
        label: "TrailBlazer",
        value: "trailblazer",
      },
      {
        label: "Malibu (Classic)",
        value: "malibu_(classic)",
      },
      {
        label: "Uplander Cargo",
        value: "uplander_cargo",
      },
      {
        label: "Uplander Passenger",
        value: "uplander_passenger",
      },
      {
        label: "Silverado (Classic) 3500 Extended Cab",
        value: "silverado_(classic)_3500_extended_cab",
      },
      {
        label: "Silverado (Classic) 2500 HD Crew Cab",
        value: "silverado_(classic)_2500_hd_crew_cab",
      },
      {
        label: "Silverado (Classic) 1500 Crew Cab",
        value: "silverado_(classic)_1500_crew_cab",
      },
      {
        label: "Silverado (Classic) 1500 Regular Cab",
        value: "silverado_(classic)_1500_regular_cab",
      },
      {
        label: "Silverado (Classic) 1500 Extended Cab",
        value: "silverado_(classic)_1500_extended_cab",
      },
      {
        label: "Silverado (Classic) 1500 HD Crew Cab",
        value: "silverado_(classic)_1500_hd_crew_cab",
      },
      {
        label: "Silverado (Classic) 3500 Crew Cab",
        value: "silverado_(classic)_3500_crew_cab",
      },
      {
        label: "Monte Carlo",
        value: "monte_carlo",
      },
      {
        label: "Silverado (Classic) 3500 Regular Cab",
        value: "silverado_(classic)_3500_regular_cab",
      },
      {
        label: "Silverado (Classic) 2500 HD Regular Cab",
        value: "silverado_(classic)_2500_hd_regular_cab",
      },
      {
        label: "Silverado (Classic) 2500 HD Extended Cab",
        value: "silverado_(classic)_2500_hd_extended_cab",
      },
      {
        label: "Avalanche 2500",
        value: "avalanche_2500",
      },
      {
        label: "Avalanche 1500",
        value: "avalanche_1500",
      },
      {
        label: "SSR",
        value: "ssr",
      },
      {
        label: "Silverado 3500 Crew Cab",
        value: "silverado_3500_crew_cab",
      },
      {
        label: "Silverado 3500 Extended Cab",
        value: "silverado_3500_extended_cab",
      },
      {
        label: "Silverado 3500 Regular Cab",
        value: "silverado_3500_regular_cab",
      },
      {
        label: "Silverado 1500 HD Crew Cab",
        value: "silverado_1500_hd_crew_cab",
      },
      {
        label: "Astro Cargo",
        value: "astro_cargo",
      },
      {
        label: "Classic",
        value: "classic",
      },
      {
        label: "Astro Passenger",
        value: "astro_passenger",
      },
      {
        label: "Cavalier",
        value: "cavalier",
      },
      {
        label: "Venture Passenger",
        value: "venture_passenger",
      },
      {
        label: "Venture Cargo",
        value: "venture_cargo",
      },
      {
        label: "Silverado 2500 Extended Cab",
        value: "silverado_2500_extended_cab",
      },
      {
        label: "S10 Crew Cab",
        value: "s10_crew_cab",
      },
      {
        label: "Silverado 2500 Crew Cab",
        value: "silverado_2500_crew_cab",
      },
      {
        label: "Silverado 2500 Regular Cab",
        value: "silverado_2500_regular_cab",
      },
      {
        label: "Tracker",
        value: "tracker",
      },
      {
        label: "S10 Extended Cab",
        value: "s10_extended_cab",
      },
      {
        label: "S10 Regular Cab",
        value: "s10_regular_cab",
      },
      {
        label: "Prizm",
        value: "prizm",
      },
      {
        label: "Metro",
        value: "metro",
      },
      {
        label: "Lumina",
        value: "lumina",
      },
      {
        label: "2500 HD Regular Cab",
        value: "2500_hd_regular_cab",
      },
      {
        label: "2500 Crew Cab",
        value: "2500_crew_cab",
      },
      {
        label: "2500 HD Extended Cab",
        value: "2500_hd_extended_cab",
      },
      {
        label: "3500 Crew Cab",
        value: "3500_crew_cab",
      },
      {
        label: "3500 Extended Cab",
        value: "3500_extended_cab",
      },
      {
        label: "3500 Regular Cab",
        value: "3500_regular_cab",
      },
      {
        label: "Tahoe (New)",
        value: "tahoe_(new)",
      },
      {
        label: "1500 Extended Cab",
        value: "1500_extended_cab",
      },
      {
        label: "2500 Regular Cab",
        value: "2500_regular_cab",
      },
      {
        label: "G-Series 1500",
        value: "g_series_1500",
      },
      {
        label: "1500 Regular Cab",
        value: "1500_regular_cab",
      },
      {
        label: "2500 Extended Cab",
        value: "2500_extended_cab",
      },
      {
        label: "G-Series 3500",
        value: "g_series_3500",
      },
      {
        label: "G-Series 2500",
        value: "g_series_2500",
      },
      {
        label: "Beretta",
        value: "beretta",
      },
      {
        label: "G-Series G30",
        value: "g_series_g30",
      },
      {
        label: "Lumina Passenger",
        value: "lumina_passenger",
      },
      {
        label: "Sportvan G30",
        value: "sportvan_g30",
      },
      {
        label: "Corsica",
        value: "corsica",
      },
      {
        label: "Lumina Cargo",
        value: "lumina_cargo",
      },
      {
        label: "Caprice Classic",
        value: "caprice_classic",
      },
      {
        label: "3500 HD Extended Cab",
        value: "3500_hd_extended_cab",
      },
      {
        label: "G-Series G20",
        value: "g_series_g20",
      },
      {
        label: "G-Series G10",
        value: "g_series_g10",
      },
      {
        label: "3500 HD Regular Cab",
        value: "3500_hd_regular_cab",
      },
      {
        label: "Sportvan G20",
        value: "sportvan_g20",
      },
      {
        label: "S10 Blazer",
        value: "s10_blazer",
      },
      {
        label: "Lumina APV",
        value: "lumina_apv",
      },
      {
        label: "Sportvan G10",
        value: "sportvan_g10",
      },
      {
        label: "APV Cargo",
        value: "apv_cargo",
      },
      {
        label: "Caprice",
        value: "caprice",
      },
      {
        label: "Trailblazer",
        value: "trailblazer",
      },
    ],
  },
  {
    make: "Chrysler",
    name: "vehicle_make_chrysler",
    label: "Vehicle Make Chrysler",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Pacifica",
        value: "pacifica",
      },
      {
        label: "Voyager",
        value: "voyager",
      },
      {
        label: "Pacifica Hybrid",
        value: "pacifica_hybrid",
      },
      {
        label: "300",
        value: "300",
      },
      {
        label: "200",
        value: "200",
      },
      {
        label: "Town & Country",
        value: "town_&_country",
      },
      {
        label: "PT Cruiser",
        value: "pt_cruiser",
      },
      {
        label: "Sebring",
        value: "sebring",
      },
      {
        label: "Aspen",
        value: "aspen",
      },
      {
        label: "Crossfire",
        value: "crossfire",
      },
      {
        label: "300M",
        value: "300m",
      },
      {
        label: "Concorde",
        value: "concorde",
      },
      {
        label: "Prowler",
        value: "prowler",
      },
      {
        label: "LHS",
        value: "lhs",
      },
      {
        label: "Cirrus",
        value: "cirrus",
      },
      {
        label: "Grand Voyager",
        value: "grand_voyager",
      },
      {
        label: "New Yorker",
        value: "new_yorker",
      },
      {
        label: "LeBaron",
        value: "lebaron",
      },
      {
        label: "Fifth Ave",
        value: "fifth_ave",
      },
      {
        label: "Imperial",
        value: "imperial",
      },
    ],
  },
  {
    make: "Citroen",
    name: "vehicle_make_citroen",
    label: "Vehicle Make Citroen",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "C3",
        value: "c3",
      },
      {
        label: "C4",
        value: "c4",
      },
      {
        label: "C5",
        value: "c5",
      },
      {
        label: "C6",
        value: "c6",
      },
    ],
  },
  {
    make: "Daewoo",
    name: "vehicle_make_daewoo",
    label: "Vehicle Make Daewoo",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Nubira",
        value: "nubira",
      },
      {
        label: "Leganza",
        value: "leganza",
      },
      {
        label: "Lanos",
        value: "lanos",
      },
    ],
  },
  {
    make: "Daihatsu",
    name: "vehicle_make_daihatsu",
    label: "Vehicle Make Daihatsu",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Rocky",
        value: "rocky",
      },
      {
        label: "Charade",
        value: "charade",
      },
    ],
  },
  {
    make: "Dodge",
    name: "vehicle_make_dodge",
    label: "Vehicle Make Dodge",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Durango",
        value: "durango",
      },
      {
        label: "Charger",
        value: "charger",
      },
      {
        label: "Challenger",
        value: "challenger",
      },
      {
        label: "Journey",
        value: "journey",
      },
      {
        label: "Grand Caravan Passenger",
        value: "grand_caravan_passenger",
      },
      {
        label: "Viper",
        value: "viper",
      },
      {
        label: "Dart",
        value: "dart",
      },
      {
        label: "Avenger",
        value: "avenger",
      },
      {
        label: "Caliber",
        value: "caliber",
      },
      {
        label: "Grand Caravan Cargo",
        value: "grand_caravan_cargo",
      },
      {
        label: "Nitro",
        value: "nitro",
      },
      {
        label: "Ram 2500 Regular Cab",
        value: "ram_2500_regular_cab",
      },
      {
        label: "Ram 1500 Quad Cab",
        value: "ram_1500_quad_cab",
      },
      {
        label: "Dakota Extended Cab",
        value: "dakota_extended_cab",
      },
      {
        label: "Ram 1500 Crew Cab",
        value: "ram_1500_crew_cab",
      },
      {
        label: "Dakota Crew Cab",
        value: "dakota_crew_cab",
      },
      {
        label: "Ram 2500 Mega Cab",
        value: "ram_2500_mega_cab",
      },
      {
        label: "Ram 1500 Regular Cab",
        value: "ram_1500_regular_cab",
      },
      {
        label: "Ram 3500 Crew Cab",
        value: "ram_3500_crew_cab",
      },
      {
        label: "Ram 2500 Crew Cab",
        value: "ram_2500_crew_cab",
      },
      {
        label: "Ram 3500 Mega Cab",
        value: "ram_3500_mega_cab",
      },
      {
        label: "Ram 3500 Regular Cab",
        value: "ram_3500_regular_cab",
      },
      {
        label: "Ram 3500 Quad Cab",
        value: "ram_3500_quad_cab",
      },
      {
        label: "Ram 2500 Quad Cab",
        value: "ram_2500_quad_cab",
      },
      {
        label: "Sprinter 2500 Cargo",
        value: "sprinter_2500_cargo",
      },
      {
        label: "Sprinter 2500 Passenger",
        value: "sprinter_2500_passenger",
      },
      {
        label: "Magnum",
        value: "magnum",
      },
      {
        label: "Ram 1500 Mega Cab",
        value: "ram_1500_mega_cab",
      },
      {
        label: "Sprinter 3500 Cargo",
        value: "sprinter_3500_cargo",
      },
      {
        label: "Caravan Passenger",
        value: "caravan_passenger",
      },
      {
        label: "Caravan Cargo",
        value: "caravan_cargo",
      },
      {
        label: "Dakota Quad Cab",
        value: "dakota_quad_cab",
      },
      {
        label: "Dakota Club Cab",
        value: "dakota_club_cab",
      },
      {
        label: "Stratus",
        value: "stratus",
      },
      {
        label: "Neon",
        value: "neon",
      },
      {
        label: "Dakota Regular Cab",
        value: "dakota_regular_cab",
      },
      {
        label: "Intrepid",
        value: "intrepid",
      },
      {
        label: "Ram Van 1500",
        value: "ram_van_1500",
      },
      {
        label: "Ram Van 2500",
        value: "ram_van_2500",
      },
      {
        label: "Ram Van 3500",
        value: "ram_van_3500",
      },
      {
        label: "Ram Wagon 2500",
        value: "ram_wagon_2500",
      },
      {
        label: "Ram Wagon 1500",
        value: "ram_wagon_1500",
      },
      {
        label: "Ram Wagon 3500",
        value: "ram_wagon_3500",
      },
      {
        label: "Ram 1500 Club Cab",
        value: "ram_1500_club_cab",
      },
      {
        label: "Ram 2500 Club Cab",
        value: "ram_2500_club_cab",
      },
      {
        label: "Ram 3500 Club Cab",
        value: "ram_3500_club_cab",
      },
      {
        label: "Stealth",
        value: "stealth",
      },
      {
        label: "Spirit",
        value: "spirit",
      },
      {
        label: "Ram Van B250",
        value: "ram_van_b250",
      },
      {
        label: "Ram Wagon B350",
        value: "ram_wagon_b350",
      },
      {
        label: "Colt",
        value: "colt",
      },
      {
        label: "Ram Van B150",
        value: "ram_van_b150",
      },
      {
        label: "Ram Van B350",
        value: "ram_van_b350",
      },
      {
        label: "Ram Wagon B150",
        value: "ram_wagon_b150",
      },
      {
        label: "Shadow",
        value: "shadow",
      },
      {
        label: "Ram Wagon B250",
        value: "ram_wagon_b250",
      },
      {
        label: "D350 Club Cab",
        value: "d350_club_cab",
      },
      {
        label: "D250 Club Cab",
        value: "d250_club_cab",
      },
      {
        label: "D150 Club Cab",
        value: "d150_club_cab",
      },
      {
        label: "D350 Regular Cab",
        value: "d350_regular_cab",
      },
      {
        label: "D150 Regular Cab",
        value: "d150_regular_cab",
      },
      {
        label: "D250 Regular Cab",
        value: "d250_regular_cab",
      },
      {
        label: "Dynasty",
        value: "dynasty",
      },
      {
        label: "Ram 50 Regular Cab",
        value: "ram_50_regular_cab",
      },
      {
        label: "Daytona",
        value: "daytona",
      },
      {
        label: "Ramcharger",
        value: "ramcharger",
      },
      {
        label: "Monaco",
        value: "monaco",
      },
    ],
  },
  {
    make: "Eagle",
    name: "vehicle_make_eagle",
    label: "Vehicle Make Eagle",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Talon",
        value: "talon",
      },
      {
        label: "Vision",
        value: "vision",
      },
      {
        label: "Summit",
        value: "summit",
      },
      {
        label: "Premier",
        value: "premier",
      },
    ],
  },
  {
    make: "Ferrari",
    name: "vehicle_make_ferrari",
    label: "Vehicle Make Ferrari",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "GTC4Lusso",
        value: "gtc4lusso",
      },
      {
        label: "488 GTB",
        value: "488_gtb",
      },
      {
        label: "812 Superfast",
        value: "812_superfast",
      },
      {
        label: "Portofino",
        value: "portofino",
      },
      {
        label: "488 Spider",
        value: "488_spider",
      },
      {
        label: "F12berlinetta",
        value: "f12berlinetta",
      },
      {
        label: "California",
        value: "california",
      },
      {
        label: "FF",
        value: "ff",
      },
      {
        label: "458 Italia",
        value: "458_italia",
      },
      {
        label: "458 Speciale",
        value: "458_speciale",
      },
      {
        label: "458 Spider",
        value: "458_spider",
      },
      {
        label: "599 GTB Fiorano",
        value: "599_gtb_fiorano",
      },
      {
        label: "599 GTO",
        value: "599_gto",
      },
      {
        label: "612 Scaglietti",
        value: "612_scaglietti",
      },
      {
        label: "430 Scuderia",
        value: "430_scuderia",
      },
      {
        label: "F430",
        value: "f430",
      },
    ],
  },
  {
    make: "FIAT",
    name: "vehicle_make_fiat",
    label: "Vehicle Make FIAT",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "500L",
        value: "500l",
      },
      {
        label: "500e",
        value: "500e",
      },
      {
        label: "500",
        value: "500",
      },
      {
        label: "500c",
        value: "500c",
      },
      {
        label: "500 Abarth",
        value: "500_abarth",
      },
      {
        label: "124 Spider",
        value: "124_spider",
      },
      {
        label: "500X",
        value: "500x",
      },
      {
        label: "500c Abarth",
        value: "500c_abarth",
      },
    ],
  },
  {
    make: "Fisker",
    name: "vehicle_make_fisker",
    label: "Vehicle Make Fisker",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Karma",
        value: "karma",
      },
    ],
  },
  {
    make: "Ford",
    name: "vehicle_make_ford",
    label: "Vehicle Make Ford",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Fusion",
        value: "fusion",
      },
      {
        label: "EcoSport",
        value: "ecosport",
      },
      {
        label: "Everest",
        value: "everest",
      },
      {
        label: "Escape",
        value: "escape",
      },
      {
        label: "Mustang",
        value: "mustang",
      },
      {
        label: "Edge",
        value: "edge",
      },
      {
        label: "Kuga",
        value: "kuga",
      },
      {
        label: "F150 SuperCrew Cab",
        value: "f150_supercrew_cab",
      },
      {
        label: "Ranger SuperCab",
        value: "ranger_supercab",
      },
      {
        label: "Expedition MAX",
        value: "expedition_max",
      },
      {
        label: "Expedition",
        value: "expedition",
      },
      {
        label: "Ranger SuperCrew",
        value: "ranger_supercrew",
      },
      {
        label: "Explorer",
        value: "explorer",
      },
      {
        label: "F150 Super Cab",
        value: "f150_super_cab",
      },
      {
        label: "F250 Super Duty Regular Cab",
        value: "f250_super_duty_regular_cab",
      },
      {
        label: "F150 Regular Cab",
        value: "f150_regular_cab",
      },
      {
        label: "F450 Super Duty Crew Cab",
        value: "f450_super_duty_crew_cab",
      },
      {
        label: "F350 Super Duty Crew Cab",
        value: "f350_super_duty_crew_cab",
      },
      {
        label: "Fiesta",
        value: "fiesta",
      },
      {
        label: "F250 Super Duty Crew Cab",
        value: "f250_super_duty_crew_cab",
      },
      {
        label: "F350 Super Duty Super Cab",
        value: "f350_super_duty_super_cab",
      },
      {
        label: "Flex",
        value: "flex",
      },
      {
        label: "Transit 150 Van",
        value: "transit_150_van",
      },
      {
        label: "Fusion Energi",
        value: "fusion_energi",
      },
      {
        label: "Transit Connect Cargo",
        value: "transit_connect_cargo",
      },
      {
        label: "Transit 150 Wagon",
        value: "transit_150_wagon",
      },
      {
        label: "Transit 350 Van",
        value: "transit_350_van",
      },
      {
        label: "F250 Super Duty Super Cab",
        value: "f250_super_duty_super_cab",
      },
      {
        label: "Transit 250 Van",
        value: "transit_250_van",
      },
      {
        label: "Transit 350 Wagon",
        value: "transit_350_wagon",
      },
      {
        label: "Transit Connect Passenger",
        value: "transit_connect_passenger",
      },
      {
        label: "Tourneo Custom",
        value: "tourneo_custom",
      },
      {
        label: "Taurus",
        value: "taurus",
      },
      {
        label: "C-MAX Hybrid",
        value: "c_max_hybrid",
      },
      {
        label: "F350 Super Duty Regular Cab",
        value: "f350_super_duty_regular_cab",
      },
      {
        label: "Focus",
        value: "focus",
      },
      {
        label: "Transit 350 HD Van",
        value: "transit_350_hd_van",
      },
      {
        label: "C-MAX Energi",
        value: "c_max_energi",
      },
      {
        label: "Expedition EL",
        value: "expedition_el",
      },
      {
        label: "Focus ST",
        value: "focus_st",
      },
      {
        label: "E350 Super Duty Cargo",
        value: "e350_super_duty_cargo",
      },
      {
        label: "E150 Passenger",
        value: "e150_passenger",
      },
      {
        label: "E150 Cargo",
        value: "e150_cargo",
      },
      {
        label: "E250 Cargo",
        value: "e250_cargo",
      },
      {
        label: "E350 Super Duty Passenger",
        value: "e350_super_duty_passenger",
      },
      {
        label: "Crown Victoria",
        value: "crown_victoria",
      },
      {
        label: "Ranger Super Cab",
        value: "ranger_super_cab",
      },
      {
        label: "Ranger Regular Cab",
        value: "ranger_regular_cab",
      },
      {
        label: "E150 Super Duty Passenger",
        value: "e150_super_duty_passenger",
      },
      {
        label: "Explorer Sport Trac",
        value: "explorer_sport_trac",
      },
      {
        label: "Taurus X",
        value: "taurus_x",
      },
      {
        label: "E250 Super Duty Cargo",
        value: "e250_super_duty_cargo",
      },
      {
        label: "E150 Super Duty Cargo",
        value: "e150_super_duty_cargo",
      },
      {
        label: "Freestar Cargo",
        value: "freestar_cargo",
      },
      {
        label: "Five Hundred",
        value: "five_hundred",
      },
      {
        label: "Freestar Passenger",
        value: "freestar_passenger",
      },
      {
        label: "Freestyle",
        value: "freestyle",
      },
      {
        label: "GT",
        value: "gt",
      },
      {
        label: "Excursion",
        value: "excursion",
      },
      {
        label: "Thunderbird",
        value: "thunderbird",
      },
      {
        label: "F150 (Heritage) Super Cab",
        value: "f150_(heritage)_super_cab",
      },
      {
        label: "F150 (Heritage) Regular Cab",
        value: "f150_(heritage)_regular_cab",
      },
      {
        label: "Explorer Sport",
        value: "explorer_sport",
      },
      {
        label: "Windstar Cargo",
        value: "windstar_cargo",
      },
      {
        label: "ZX2",
        value: "zx2",
      },
      {
        label: "Windstar Passenger",
        value: "windstar_passenger",
      },
      {
        label: "Econoline E250 Cargo",
        value: "econoline_e250_cargo",
      },
      {
        label: "Econoline E350 Super Duty Passenger",
        value: "econoline_e350_super_duty_passenger",
      },
      {
        label: "Econoline E150 Cargo",
        value: "econoline_e150_cargo",
      },
      {
        label: "Econoline E150 Passenger",
        value: "econoline_e150_passenger",
      },
      {
        label: "Econoline E350 Super Duty Cargo",
        value: "econoline_e350_super_duty_cargo",
      },
      {
        label: "Escort",
        value: "escort",
      },
      {
        label: "Contour",
        value: "contour",
      },
      {
        label: "Econoline E350 Cargo",
        value: "econoline_e350_cargo",
      },
      {
        label: "F250 Regular Cab",
        value: "f250_regular_cab",
      },
      {
        label: "F250 Super Cab",
        value: "f250_super_cab",
      },
      {
        label: "Club Wagon",
        value: "club_wagon",
      },
      {
        label: "Aerostar Passenger",
        value: "aerostar_passenger",
      },
      {
        label: "Aspire",
        value: "aspire",
      },
      {
        label: "Aerostar Cargo",
        value: "aerostar_cargo",
      },
      {
        label: "Probe",
        value: "probe",
      },
      {
        label: "F350 Crew Cab",
        value: "f350_crew_cab",
      },
      {
        label: "F350 Regular Cab",
        value: "f350_regular_cab",
      },
      {
        label: "F250 Crew Cab",
        value: "f250_crew_cab",
      },
      {
        label: "F350 Super Cab",
        value: "f350_super_cab",
      },
      {
        label: "Bronco",
        value: "bronco",
      },
      {
        label: "Tempo",
        value: "tempo",
      },
      {
        label: "Festiva",
        value: "festiva",
      },
      {
        label: "Bronco Sport",
        value: "bronco_sport",
      },
      {
        label: "Transit Connect Cargo Van",
        value: "transit_connect_cargo_van",
      },
    ],
  },
  {
    make: "Freightliner",
    name: "vehicle_make_freightliner",
    label: "Vehicle Make Freightliner",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Sprinter 2500 Cargo",
        value: "sprinter_2500_cargo",
      },
      {
        label: "Sprinter 2500 Crew",
        value: "sprinter_2500_crew",
      },
      {
        label: "Sprinter 3500 Cargo",
        value: "sprinter_3500_cargo",
      },
      {
        label: "Sprinter WORKER Cargo",
        value: "sprinter_worker_cargo",
      },
      {
        label: "Sprinter 3500XD Cargo",
        value: "sprinter_3500xd_cargo",
      },
      {
        label: "Sprinter 2500 Passenger",
        value: "sprinter_2500_passenger",
      },
      {
        label: "Sprinter WORKER Passenger",
        value: "sprinter_worker_passenger",
      },
    ],
  },
  {
    make: "Genesis",
    name: "vehicle_make_genesis",
    label: "Vehicle Make Genesis",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "G70",
        value: "g70",
      },
      {
        label: "G80",
        value: "g80",
      },
      {
        label: "G90",
        value: "g90",
      },
      {
        label: "GV80",
        value: "gv80",
      },
    ],
  },
  {
    make: "Geo",
    name: "vehicle_make_geo",
    label: "Vehicle Make Geo",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Metro",
        value: "metro",
      },
      {
        label: "Prizm",
        value: "prizm",
      },
      {
        label: "Tracker",
        value: "tracker",
      },
      {
        label: "Storm",
        value: "storm",
      },
    ],
  },
  {
    make: "GMC",
    name: "vehicle_make_gmc",
    label: "Vehicle Make GMC",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Sierra 2500 HD Crew Cab",
        value: "sierra_2500_hd_crew_cab",
      },
      {
        label: "Sierra 3500 HD Crew Cab",
        value: "sierra_3500_hd_crew_cab",
      },
      {
        label: "Terrain",
        value: "terrain",
      },
      {
        label: "Sierra 1500 Crew Cab",
        value: "sierra_1500_crew_cab",
      },
      {
        label: "Yukon XL",
        value: "yukon_xl",
      },
      {
        label: "Yukon",
        value: "yukon",
      },
      {
        label: "Acadia",
        value: "acadia",
      },
      {
        label: "Canyon Crew Cab",
        value: "canyon_crew_cab",
      },
      {
        label: "Sierra 1500 Double Cab",
        value: "sierra_1500_double_cab",
      },
      {
        label: "Sierra 1500 Limited Double Cab",
        value: "sierra_1500_limited_double_cab",
      },
      {
        label: "Sierra 2500 HD Double Cab",
        value: "sierra_2500_hd_double_cab",
      },
      {
        label: "Sierra 2500 HD Regular Cab",
        value: "sierra_2500_hd_regular_cab",
      },
      {
        label: "Canyon Extended Cab",
        value: "canyon_extended_cab",
      },
      {
        label: "Sierra 1500 Regular Cab",
        value: "sierra_1500_regular_cab",
      },
      {
        label: "Savana 2500 Passenger",
        value: "savana_2500_passenger",
      },
      {
        label: "Savana 3500 Passenger",
        value: "savana_3500_passenger",
      },
      {
        label: "Savana 3500 Cargo",
        value: "savana_3500_cargo",
      },
      {
        label: "Savana 2500 Cargo",
        value: "savana_2500_cargo",
      },
      {
        label: "Sierra 3500 HD Double Cab",
        value: "sierra_3500_hd_double_cab",
      },
      {
        label: "Sierra 3500 HD Regular Cab",
        value: "sierra_3500_hd_regular_cab",
      },
      {
        label: "Acadia Limited",
        value: "acadia_limited",
      },
      {
        label: "Savana 1500 Cargo",
        value: "savana_1500_cargo",
      },
      {
        label: "Savana 1500 Passenger",
        value: "savana_1500_passenger",
      },
      {
        label: "Yukon XL 1500",
        value: "yukon_xl_1500",
      },
      {
        label: "Sierra 3500 HD Extended Cab",
        value: "sierra_3500_hd_extended_cab",
      },
      {
        label: "Sierra 1500 Extended Cab",
        value: "sierra_1500_extended_cab",
      },
      {
        label: "Yukon XL 2500",
        value: "yukon_xl_2500",
      },
      {
        label: "Sierra 2500 HD Extended Cab",
        value: "sierra_2500_hd_extended_cab",
      },
      {
        label: "Canyon Regular Cab",
        value: "canyon_regular_cab",
      },
      {
        label: "Envoy",
        value: "envoy",
      },
      {
        label: "Sierra (Classic) 1500 HD Crew Cab",
        value: "sierra_(classic)_1500_hd_crew_cab",
      },
      {
        label: "Sierra (Classic) 3500 Crew Cab",
        value: "sierra_(classic)_3500_crew_cab",
      },
      {
        label: "Sierra (Classic) 1500 Crew Cab",
        value: "sierra_(classic)_1500_crew_cab",
      },
      {
        label: "Sierra (Classic) 1500 Extended Cab",
        value: "sierra_(classic)_1500_extended_cab",
      },
      {
        label: "Sierra (Classic) 2500 HD Crew Cab",
        value: "sierra_(classic)_2500_hd_crew_cab",
      },
      {
        label: "Sierra (Classic) 1500 Regular Cab",
        value: "sierra_(classic)_1500_regular_cab",
      },
      {
        label: "Sierra (Classic) 3500 Extended Cab",
        value: "sierra_(classic)_3500_extended_cab",
      },
      {
        label: "Sierra (Classic) 3500 Regular Cab",
        value: "sierra_(classic)_3500_regular_cab",
      },
      {
        label: "Sierra (Classic) 2500 HD Extended Cab",
        value: "sierra_(classic)_2500_hd_extended_cab",
      },
      {
        label: "Sierra (Classic) 2500 HD Regular Cab",
        value: "sierra_(classic)_2500_hd_regular_cab",
      },
      {
        label: "Envoy XL",
        value: "envoy_xl",
      },
      {
        label: "Sierra 3500 Crew Cab",
        value: "sierra_3500_crew_cab",
      },
      {
        label: "Sierra 1500 HD Crew Cab",
        value: "sierra_1500_hd_crew_cab",
      },
      {
        label: "Sierra 3500 Extended Cab",
        value: "sierra_3500_extended_cab",
      },
      {
        label: "Sierra 3500 Regular Cab",
        value: "sierra_3500_regular_cab",
      },
      {
        label: "Envoy XUV",
        value: "envoy_xuv",
      },
      {
        label: "Safari Cargo",
        value: "safari_cargo",
      },
      {
        label: "Safari Passenger",
        value: "safari_passenger",
      },
      {
        label: "Sierra 2500 Regular Cab",
        value: "sierra_2500_regular_cab",
      },
      {
        label: "Sonoma Crew Cab",
        value: "sonoma_crew_cab",
      },
      {
        label: "Sierra 2500 Crew Cab",
        value: "sierra_2500_crew_cab",
      },
      {
        label: "Sierra 2500 Extended Cab",
        value: "sierra_2500_extended_cab",
      },
      {
        label: "Sonoma Extended Cab",
        value: "sonoma_extended_cab",
      },
      {
        label: "Sonoma Regular Cab",
        value: "sonoma_regular_cab",
      },
      {
        label: "Jimmy",
        value: "jimmy",
      },
      {
        label: "Yukon Denali",
        value: "yukon_denali",
      },
      {
        label: "Sierra (Classic) 2500 Crew Cab",
        value: "sierra_(classic)_2500_crew_cab",
      },
      {
        label: "2500 Crew Cab",
        value: "2500_crew_cab",
      },
      {
        label: "3500 Regular Cab",
        value: "3500_regular_cab",
      },
      {
        label: "1500 Club Coupe",
        value: "1500_club_coupe",
      },
      {
        label: "3500 Extended Cab",
        value: "3500_extended_cab",
      },
      {
        label: "2500 HD Regular Cab",
        value: "2500_hd_regular_cab",
      },
      {
        label: "2500 HD Extended Cab",
        value: "2500_hd_extended_cab",
      },
      {
        label: "3500 Crew Cab",
        value: "3500_crew_cab",
      },
      {
        label: "Suburban 2500",
        value: "suburban_2500",
      },
      {
        label: "Suburban 1500",
        value: "suburban_1500",
      },
      {
        label: "2500 Club Coupe",
        value: "2500_club_coupe",
      },
      {
        label: "2500 Regular Cab",
        value: "2500_regular_cab",
      },
      {
        label: "1500 Regular Cab",
        value: "1500_regular_cab",
      },
      {
        label: "3500 Club Coupe",
        value: "3500_club_coupe",
      },
      {
        label: "Sonoma Club Coupe Cab",
        value: "sonoma_club_coupe_cab",
      },
      {
        label: "2500 HD Club Coupe",
        value: "2500_hd_club_coupe",
      },
      {
        label: "Rally Wagon G3500",
        value: "rally_wagon_g3500",
      },
      {
        label: "Vandura G3500",
        value: "vandura_g3500",
      },
      {
        label: "Rally Wagon G2500",
        value: "rally_wagon_g2500",
      },
      {
        label: "Vandura G2500",
        value: "vandura_g2500",
      },
      {
        label: "Vandura G1500",
        value: "vandura_g1500",
      },
      {
        label: "Rally Wagon 2500",
        value: "rally_wagon_2500",
      },
      {
        label: "Rally Wagon 3500",
        value: "rally_wagon_3500",
      },
      {
        label: "Vandura 1500",
        value: "vandura_1500",
      },
      {
        label: "Vandura 3500",
        value: "vandura_3500",
      },
      {
        label: "Vandura 2500",
        value: "vandura_2500",
      },
      {
        label: "Rally Wagon 1500",
        value: "rally_wagon_1500",
      },
      {
        label: "Sonoma Club Cab",
        value: "sonoma_club_cab",
      },
      {
        label: "Hummer EV",
        value: "hummer_ev",
      },
    ],
  },
  {
    make: "GWM",
    name: "vehicle_make_gwm",
    label: "Vehicle Make GWM",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Steed 5",
        value: "steed_5",
      },
      {
        label: "P Series",
        value: "p_series",
      },
    ],
  },
  {
    make: "Haval",
    name: "vehicle_make_haval",
    label: "Vehicle Make Haval",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "H1",
        value: "h1",
      },
      {
        label: "H2",
        value: "h2",
      },
      {
        label: "H4",
        value: "h4",
      },
      {
        label: "H5",
        value: "h5",
      },
      {
        label: "H6",
        value: "h6",
      },
      {
        label: "Jolion",
        value: "jolion",
      },
    ],
  },
  {
    make: "Honda",
    name: "vehicle_make_honda",
    label: "Vehicle Make Honda",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Insight",
        value: "insight",
      },
      {
        label: "Civic",
        value: "civic",
      },
      {
        label: "Jazz",
        value: "jazz",
      },
      {
        label: "Accord Hybrid",
        value: "accord_hybrid",
      },
      {
        label: "Odyssey",
        value: "odyssey",
      },
      {
        label: "Ridgeline",
        value: "ridgeline",
      },
      {
        label: "Passport",
        value: "passport",
      },
      {
        label: "Accord",
        value: "accord",
      },
      {
        label: "Pilot",
        value: "pilot",
      },
      {
        label: "CR-V",
        value: "cr_v",
      },
      {
        label: "HR-V",
        value: "hr_v",
      },
      {
        label: "Clarity Electric",
        value: "clarity_electric",
      },
      {
        label: "Civic Type R",
        value: "civic_type_r",
      },
      {
        label: "Clarity Fuel Cell",
        value: "clarity_fuel_cell",
      },
      {
        label: "Clarity Plug-in Hybrid",
        value: "clarity_plug_in_hybrid",
      },
      {
        label: "Fit",
        value: "fit",
      },
      {
        label: "CR-Z",
        value: "cr_z",
      },
      {
        label: "Crosstour",
        value: "crosstour",
      },
      {
        label: "Accord Crosstour",
        value: "accord_crosstour",
      },
      {
        label: "Element",
        value: "element",
      },
      {
        label: "S2000",
        value: "s2000",
      },
      {
        label: "Prelude",
        value: "prelude",
      },
      {
        label: "del Sol",
        value: "del_sol",
      },
      {
        label: "CR-V Hybrid",
        value: "cr_v_hybrid",
      },
    ],
  },
  {
    make: "HUMMER",
    name: "vehicle_make_hummer",
    label: "Vehicle Make HUMMER",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "H3T",
        value: "h3t",
      },
      {
        label: "H3",
        value: "h3",
      },
      {
        label: "H2",
        value: "h2",
      },
      {
        label: "H1",
        value: "h1",
      },
    ],
  },
  {
    make: "Hyundai",
    name: "vehicle_make_hyundai",
    label: "Vehicle Make Hyundai",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Santa Fe",
        value: "santa_fe",
      },
      {
        label: "Sonata",
        value: "sonata",
      },
      {
        label: "Kona Electric",
        value: "kona_electric",
      },
      {
        label: "NEXO",
        value: "nexo",
      },
      {
        label: "Veloster",
        value: "veloster",
      },
      {
        label: "Elantra GT",
        value: "elantra_gt",
      },
      {
        label: "Kona",
        value: "kona",
      },
      {
        label: "Getz",
        value: "getz",
      },
      {
        label: "Palisade",
        value: "palisade",
      },
      {
        label: "Elantra",
        value: "elantra",
      },
      {
        label: "Venue",
        value: "venue",
      },
      {
        label: "Ioniq Plug-in Hybrid",
        value: "ioniq_plug_in_hybrid",
      },
      {
        label: "Tucson",
        value: "tucson",
      },
      {
        label: "Accent",
        value: "accent",
      },
      {
        label: "Ioniq Electric",
        value: "ioniq_electric",
      },
      {
        label: "Sonata Hybrid",
        value: "sonata_hybrid",
      },
      {
        label: "Ioniq Hybrid",
        value: "ioniq_hybrid",
      },
      {
        label: "Sonata Plug-in Hybrid",
        value: "sonata_plug_in_hybrid",
      },
      {
        label: "Santa Fe XL",
        value: "santa_fe_xl",
      },
      {
        label: "Santa Fe Sport",
        value: "santa_fe_sport",
      },
      {
        label: "Azera",
        value: "azera",
      },
      {
        label: "Tucson Fuel Cell",
        value: "tucson_fuel_cell",
      },
      {
        label: "Terracan",
        value: "terracan",
      },
      {
        label: "Genesis",
        value: "genesis",
      },
      {
        label: "Genesis Coupe",
        value: "genesis_coupe",
      },
      {
        label: "Equus",
        value: "equus",
      },
      {
        label: "Veracruz",
        value: "veracruz",
      },
      {
        label: "Entourage",
        value: "entourage",
      },
      {
        label: "Tiburon",
        value: "tiburon",
      },
      {
        label: "XG350",
        value: "xg350",
      },
      {
        label: "XG300",
        value: "xg300",
      },
      {
        label: "Scoupe",
        value: "scoupe",
      },
      {
        label: "Excel",
        value: "excel",
      },
      {
        label: "H1",
        value: "h1",
      },
      {
        label: "Staria",
        value: "staria",
      },
    ],
  },
  {
    make: "INFINITI",
    name: "vehicle_make_infiniti",
    label: "Vehicle Make INFINITI",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "QX80",
        value: "qx80",
      },
      {
        label: "QX50",
        value: "qx50",
      },
      {
        label: "QX60",
        value: "qx60",
      },
      {
        label: "Q60",
        value: "q60",
      },
      {
        label: "Q50",
        value: "q50",
      },
      {
        label: "Q70",
        value: "q70",
      },
      {
        label: "QX30",
        value: "qx30",
      },
      {
        label: "QX70",
        value: "qx70",
      },
      {
        label: "Q40",
        value: "q40",
      },
      {
        label: "EX",
        value: "ex",
      },
      {
        label: "QX",
        value: "qx",
      },
      {
        label: "G",
        value: "g",
      },
      {
        label: "JX",
        value: "jx",
      },
      {
        label: "FX",
        value: "fx",
      },
      {
        label: "M",
        value: "m",
      },
      {
        label: "Q",
        value: "q",
      },
      {
        label: "I",
        value: "i",
      },
      {
        label: "J",
        value: "j",
      },
    ],
  },
  {
    make: "Isuzu",
    name: "vehicle_make_isuzu",
    label: "Vehicle Make Isuzu",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "i-370 Extended Cab",
        value: "i_370_extended_cab",
      },
      {
        label: "i-290 Extended Cab",
        value: "i_290_extended_cab",
      },
      {
        label: "Ascender",
        value: "ascender",
      },
      {
        label: "i-370 Crew Cab",
        value: "i_370_crew_cab",
      },
      {
        label: "i-350 Crew Cab",
        value: "i_350_crew_cab",
      },
      {
        label: "i-280 Extended Cab",
        value: "i_280_extended_cab",
      },
      {
        label: "KB300",
        value: "kb300",
      },
      {
        label: "D-Max",
        value: "d_max",
      },
      {
        label: "Axiom",
        value: "axiom",
      },
      {
        label: "Rodeo",
        value: "rodeo",
      },
      {
        label: "Rodeo Sport",
        value: "rodeo_sport",
      },
      {
        label: "Trooper",
        value: "trooper",
      },
      {
        label: "VehiCROSS",
        value: "vehicross",
      },
      {
        label: "Amigo",
        value: "amigo",
      },
      {
        label: "Hombre Spacecab",
        value: "hombre_spacecab",
      },
      {
        label: "Hombre Regular Cab",
        value: "hombre_regular_cab",
      },
      {
        label: "Oasis",
        value: "oasis",
      },
      {
        label: "Regular Cab",
        value: "regular_cab",
      },
      {
        label: "Spacecab",
        value: "spacecab",
      },
      {
        label: "Stylus",
        value: "stylus",
      },
      {
        label: "Impulse",
        value: "impulse",
      },
    ],
  },
  {
    make: "Jaguar",
    name: "vehicle_make_jaguar",
    label: "Vehicle Make Jaguar",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "E-PACE",
        value: "e_pace",
      },
      {
        label: "I-PACE",
        value: "i_pace",
      },
      {
        label: "F-PACE",
        value: "f_pace",
      },
      {
        label: "F-TYPE",
        value: "f_type",
      },
      {
        label: "E-TYPE",
        value: "e_type",
      },
      {
        label: "XE",
        value: "xe",
      },
      {
        label: "XF",
        value: "xf",
      },
      {
        label: "XJ",
        value: "xj",
      },
      {
        label: "XK",
        value: "xk",
      },
      {
        label: "S-Type",
        value: "s_type",
      },
      {
        label: "X-Type",
        value: "x_type",
      },
    ],
  },
  {
    make: "Jeep",
    name: "vehicle_make_jeep",
    label: "Vehicle Make Jeep",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Gladiator",
        value: "gladiator",
      },
      {
        label: "Compass",
        value: "compass",
      },
      {
        label: "Cherokee",
        value: "cherokee",
      },
      {
        label: "Grand Cherokee",
        value: "grand_cherokee",
      },
      {
        label: "Renegade",
        value: "renegade",
      },
      {
        label: "Wrangler",
        value: "wrangler",
      },
      {
        label: "Wrangler Unlimited",
        value: "wrangler_unlimited",
      },
      {
        label: "Patriot",
        value: "patriot",
      },
      {
        label: "Liberty",
        value: "liberty",
      },
      {
        label: "Commander",
        value: "commander",
      },
      {
        label: "Comanche Regular Cab",
        value: "comanche_regular_cab",
      },
      {
        label: "Grand Cherokee L",
        value: "grand_cherokee_l",
      },
      {
        label: "Grand Wagoneer",
        value: "grand_wagoneer",
      },
    ],
  },
  {
    make: "Kia",
    name: "vehicle_make_kia",
    label: "Vehicle Make Kia",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Sorento",
        value: "sorento",
      },
      {
        label: "Rio",
        value: "rio",
      },
      {
        label: "Sedona",
        value: "sedona",
      },
      {
        label: "Optima",
        value: "optima",
      },
      {
        label: "Sportage",
        value: "sportage",
      },
      {
        label: "Optima Hybrid",
        value: "optima_hybrid",
      },
      {
        label: "Optima Plug-in Hybrid",
        value: "optima_plug_in_hybrid",
      },
      {
        label: "Telluride",
        value: "telluride",
      },
      {
        label: "Forte",
        value: "forte",
      },
      {
        label: "Soul",
        value: "soul",
      },
      {
        label: "Stinger",
        value: "stinger",
      },
      {
        label: "Niro",
        value: "niro",
      },
      {
        label: "Niro Plug-in Hybrid",
        value: "niro_plug_in_hybrid",
      },
      {
        label: "Cadenza",
        value: "cadenza",
      },
      {
        label: "K900",
        value: "k900",
      },
      {
        label: "Niro EV",
        value: "niro_ev",
      },
      {
        label: "Soul EV",
        value: "soul_ev",
      },
      {
        label: "Forte5",
        value: "forte5",
      },
      {
        label: "Forte Koup",
        value: "forte_koup",
      },
      {
        label: "Rondo",
        value: "rondo",
      },
      {
        label: "Amanti",
        value: "amanti",
      },
      {
        label: "Borrego",
        value: "borrego",
      },
      {
        label: "Spectra",
        value: "spectra",
      },
      {
        label: "Optima (2006.5)",
        value: "optima_(2006.5)",
      },
      {
        label: "Sephia",
        value: "sephia",
      },
      {
        label: "K5",
        value: "k5",
      },
      {
        label: "Seltos",
        value: "seltos",
      },
      {
        label: "Sonet",
        value: "sonet",
      },
    ],
  },
  {
    make: "Lamborghini",
    name: "vehicle_make_lamborghini",
    label: "Vehicle Make Lamborghini",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Huracan",
        value: "huracan",
      },
      {
        label: "Aventador",
        value: "aventador",
      },
      {
        label: "Gallardo",
        value: "gallardo",
      },
      {
        label: "Murcielago",
        value: "murcielago",
      },
      {
        label: "Murcielago LP640",
        value: "murcielago_lp640",
      },
    ],
  },
  {
    make: "Land Rover",
    name: "vehicle_make_land_rover",
    label: "Vehicle Make Land Rover",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Discovery Sport",
        value: "discovery_sport",
      },
      {
        label: "Range Rover Evoque",
        value: "range_rover_evoque",
      },
      {
        label: "Range Rover Sport",
        value: "range_rover_sport",
      },
      {
        label: "Range Rover",
        value: "range_rover",
      },
      {
        label: "Discovery",
        value: "discovery",
      },
      {
        label: "Range Rover Velar",
        value: "range_rover_velar",
      },
      {
        label: "LR4",
        value: "lr4",
      },
      {
        label: "LR2",
        value: "lr2",
      },
      {
        label: "LR3",
        value: "lr3",
      },
      {
        label: "Freelander",
        value: "freelander",
      },
      {
        label: "Discovery Series II",
        value: "discovery_series_ii",
      },
      {
        label: "Defender 90",
        value: "defender_90",
      },
      {
        label: "Defender 110",
        value: "defender_110",
      },
    ],
  },
  {
    make: "Lexus",
    name: "vehicle_make_lexus",
    label: "Vehicle Make Lexus",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "ES",
        value: "es",
      },
      {
        label: "LC",
        value: "lc",
      },
      {
        label: "LX",
        value: "lx",
      },
      {
        label: "RC",
        value: "rc",
      },
      {
        label: "GX",
        value: "gx",
      },
      {
        label: "IS",
        value: "is",
      },
      {
        label: "GS",
        value: "gs",
      },
      {
        label: "LS",
        value: "ls",
      },
      {
        label: "UX",
        value: "ux",
      },
      {
        label: "NX",
        value: "nx",
      },
      {
        label: "RX",
        value: "rx",
      },
      {
        label: "CT",
        value: "ct",
      },
      {
        label: "HS",
        value: "hs",
      },
      {
        label: "LFA",
        value: "lfa",
      },
      {
        label: "IS F",
        value: "is_f",
      },
      {
        label: "SC",
        value: "sc",
      },
    ],
  },
  {
    make: "Lincoln",
    name: "vehicle_make_lincoln",
    label: "Vehicle Make Lincoln",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "MKZ",
        value: "mkz",
      },
      {
        label: "Aviator",
        value: "aviator",
      },
      {
        label: "Navigator",
        value: "navigator",
      },
      {
        label: "Corsair",
        value: "corsair",
      },
      {
        label: "Navigator L",
        value: "navigator_l",
      },
      {
        label: "Nautilus",
        value: "nautilus",
      },
      {
        label: "Continental",
        value: "continental",
      },
      {
        label: "MKT",
        value: "mkt",
      },
      {
        label: "MKC",
        value: "mkc",
      },
      {
        label: "MKX",
        value: "mkx",
      },
      {
        label: "MKS",
        value: "mks",
      },
      {
        label: "Town Car",
        value: "town_car",
      },
      {
        label: "Mark LT",
        value: "mark_lt",
      },
      {
        label: "LS",
        value: "ls",
      },
      {
        label: "Zephyr",
        value: "zephyr",
      },
      {
        label: "Blackwood",
        value: "blackwood",
      },
      {
        label: "Mark VIII",
        value: "mark_viii",
      },
      {
        label: "Mark VII",
        value: "mark_vii",
      },
    ],
  },
  {
    make: "Lotus",
    name: "vehicle_make_lotus",
    label: "Vehicle Make Lotus",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Evora 400",
        value: "evora_400",
      },
      {
        label: "Evora",
        value: "evora",
      },
      {
        label: "Elise",
        value: "elise",
      },
      {
        label: "Exige",
        value: "exige",
      },
      {
        label: "Exige S",
        value: "exige_s",
      },
    ],
  },
  {
    make: "Maserati",
    name: "vehicle_make_maserati",
    label: "Vehicle Make Maserati",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Levante",
        value: "levante",
      },
      {
        label: "Ghibli",
        value: "ghibli",
      },
      {
        label: "Quattroporte",
        value: "quattroporte",
      },
      {
        label: "GranTurismo",
        value: "granturismo",
      },
      {
        label: "GranSport",
        value: "gransport",
      },
      {
        label: "Coupe",
        value: "coupe",
      },
    ],
  },
  {
    make: "Maybach",
    name: "vehicle_make_maybach",
    label: "Vehicle Make Maybach",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "62",
        value: "62",
      },
      {
        label: "57",
        value: "57",
      },
    ],
  },
  {
    make: "MAZDA",
    name: "vehicle_make_mazda",
    label: "Vehicle Make MAZDA",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "CX-30",
        value: "cx_30",
      },
      {
        label: "MAZDA3",
        value: "mazda3",
      },
      {
        label: "CX-5",
        value: "cx_5",
      },
      {
        label: "MAZDA6",
        value: "mazda6",
      },
      {
        label: "CX-9",
        value: "cx_9",
      },
      {
        label: "MX-5 Miata RF",
        value: "mx_5_miata_rf",
      },
      {
        label: "MX-5 Miata",
        value: "mx_5_miata",
      },
      {
        label: "CX-3",
        value: "cx_3",
      },
      {
        label: "MAZDA5",
        value: "mazda5",
      },
      {
        label: "MAZDA2",
        value: "mazda2",
      },
      {
        label: "CX-7",
        value: "cx_7",
      },
      {
        label: "RX-8",
        value: "rx_8",
      },
      {
        label: "Tribute",
        value: "tribute",
      },
      {
        label: "B-Series Regular Cab",
        value: "b_series_regular_cab",
      },
      {
        label: "B-Series Extended Cab",
        value: "b_series_extended_cab",
      },
      {
        label: "MPV",
        value: "mpv",
      },
      {
        label: "B-Series Cab Plus",
        value: "b_series_cab_plus",
      },
      {
        label: "Protege5",
        value: "protege5",
      },
      {
        label: "Protege",
        value: "protege",
      },
      {
        label: "626",
        value: "626",
      },
      {
        label: "Millenia",
        value: "millenia",
      },
      {
        label: "MX-6",
        value: "mx_6",
      },
      {
        label: "MX-3",
        value: "mx_3",
      },
      {
        label: "929",
        value: "929",
      },
      {
        label: "RX-7",
        value: "rx_7",
      },
      {
        label: "323",
        value: "323",
      },
      {
        label: "Navajo",
        value: "navajo",
      },
    ],
  },
  {
    make: "McLaren",
    name: "vehicle_make_mclaren",
    label: "Vehicle Make McLaren",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "570GT",
        value: "570gt",
      },
      {
        label: "720S",
        value: "720s",
      },
      {
        label: "570S",
        value: "570s",
      },
      {
        label: "650S",
        value: "650s",
      },
      {
        label: "675LT",
        value: "675lt",
      },
      {
        label: "MP4-12C",
        value: "mp4_12c",
      },
    ],
  },
  {
    make: "Mercedes-Benz",
    name: "vehicle_make_mercedes_benz",
    label: "Vehicle Make Mercedes-Benz",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "GLS",
        value: "gls",
      },
      {
        label: "CLA",
        value: "cla",
      },
      {
        label: "G-Class",
        value: "g_class",
      },
      {
        label: "C-Class",
        value: "c_class",
      },
      {
        label: "GLA",
        value: "gla",
      },
      {
        label: "E-Class",
        value: "e_class",
      },
      {
        label: "GLE",
        value: "gle",
      },
      {
        label: "GLC",
        value: "glc",
      },
      {
        label: "A-Class",
        value: "a_class",
      },
      {
        label: "Mercedes-AMG C-Class",
        value: "mercedes_amg_c_class",
      },
      {
        label: "CLS",
        value: "cls",
      },
      {
        label: "Mercedes-AMG CLA",
        value: "mercedes_amg_cla",
      },
      {
        label: "GLC Coupe",
        value: "glc_coupe",
      },
      {
        label: "Mercedes-AMG CLS",
        value: "mercedes_amg_cls",
      },
      {
        label: "Mercedes-AMG E-Class",
        value: "mercedes_amg_e_class",
      },
      {
        label: "Mercedes-AMG GLE",
        value: "mercedes_amg_gle",
      },
      {
        label: "Mercedes-AMG G-Class",
        value: "mercedes_amg_g_class",
      },
      {
        label: "Mercedes-AMG GLA",
        value: "mercedes_amg_gla",
      },
      {
        label: "Mercedes-AMG S-Class",
        value: "mercedes_amg_s_class",
      },
      {
        label: "SL",
        value: "sl",
      },
      {
        label: "Mercedes-AMG GT",
        value: "mercedes_amg_gt",
      },
      {
        label: "Metris Passenger",
        value: "metris_passenger",
      },
      {
        label: "Mercedes-AMG GLE Coupe",
        value: "mercedes_amg_gle_coupe",
      },
      {
        label: "Mercedes-Maybach S-Class",
        value: "mercedes_maybach_s_class",
      },
      {
        label: "Mercedes-AMG GLC Coupe",
        value: "mercedes_amg_glc_coupe",
      },
      {
        label: "Sprinter 2500 Cargo",
        value: "sprinter_2500_cargo",
      },
      {
        label: "S-Class",
        value: "s_class",
      },
      {
        label: "Metris Cargo",
        value: "metris_cargo",
      },
      {
        label: "SLC",
        value: "slc",
      },
      {
        label: "Mercedes-AMG SLC",
        value: "mercedes_amg_slc",
      },
      {
        label: "Mercedes-AMG GLC",
        value: "mercedes_amg_glc",
      },
      {
        label: "Mercedes-AMG SL",
        value: "mercedes_amg_sl",
      },
      {
        label: "Mercedes-AMG GLS",
        value: "mercedes_amg_gls",
      },
      {
        label: "Sprinter 2500 Crew",
        value: "sprinter_2500_crew",
      },
      {
        label: "Metris WORKER Cargo",
        value: "metris_worker_cargo",
      },
      {
        label: "Metris WORKER Passenger",
        value: "metris_worker_passenger",
      },
      {
        label: "Sprinter 3500 XD Cargo",
        value: "sprinter_3500_xd_cargo",
      },
      {
        label: "Sprinter 2500 Passenger",
        value: "sprinter_2500_passenger",
      },
      {
        label: "Sprinter WORKER Cargo",
        value: "sprinter_worker_cargo",
      },
      {
        label: "Sprinter 3500 Cargo",
        value: "sprinter_3500_cargo",
      },
      {
        label: "B-Class",
        value: "b_class",
      },
      {
        label: "Sprinter WORKER Passenger",
        value: "sprinter_worker_passenger",
      },
      {
        label: "CLS-Class",
        value: "cls_class",
      },
      {
        label: "GL-Class",
        value: "gl_class",
      },
      {
        label: "GLE Coupe",
        value: "gle_coupe",
      },
      {
        label: "Mercedes-Maybach S 600",
        value: "mercedes_maybach_s_600",
      },
      {
        label: "SLK",
        value: "slk",
      },
      {
        label: "Mercedes-AMG SLK",
        value: "mercedes_amg_slk",
      },
      {
        label: "M-Class",
        value: "m_class",
      },
      {
        label: "CLA-Class",
        value: "cla_class",
      },
      {
        label: "GLK-Class",
        value: "glk_class",
      },
      {
        label: "GLA-Class",
        value: "gla_class",
      },
      {
        label: "SLS-Class",
        value: "sls_class",
      },
      {
        label: "SL-Class",
        value: "sl_class",
      },
      {
        label: "SLK-Class",
        value: "slk_class",
      },
      {
        label: "CL-Class",
        value: "cl_class",
      },
      {
        label: "R-Class",
        value: "r_class",
      },
      {
        label: "CLK-Class",
        value: "clk_class",
      },
      {
        label: "SLR McLaren",
        value: "slr_mclaren",
      },
      {
        label: "ML250",
        value: "ml250",
      },
      {
        label: "300 E",
        value: "300_e",
      },
      {
        label: "190 E",
        value: "190_e",
      },
      {
        label: "300 D",
        value: "300_d",
      },
      {
        label: "300 SD",
        value: "300_sd",
      },
      {
        label: "300 CE",
        value: "300_ce",
      },
      {
        label: "500 SEL",
        value: "500_sel",
      },
      {
        label: "400 SEL",
        value: "400_sel",
      },
      {
        label: "500 SL",
        value: "500_sl",
      },
      {
        label: "500 E",
        value: "500_e",
      },
      {
        label: "300 SL",
        value: "300_sl",
      },
      {
        label: "600 SEC",
        value: "600_sec",
      },
      {
        label: "300 TE",
        value: "300_te",
      },
      {
        label: "400 E",
        value: "400_e",
      },
      {
        label: "300 SE",
        value: "300_se",
      },
      {
        label: "600 SL",
        value: "600_sl",
      },
      {
        label: "600 SEL",
        value: "600_sel",
      },
      {
        label: "500 SEC",
        value: "500_sec",
      },
      {
        label: "400 SE",
        value: "400_se",
      },
      {
        label: "GLB",
        value: "glb",
      },
      {
        label: "V200",
        value: "v200",
      },
      {
        label: "V300",
        value: "v300",
      },
    ],
  },
  {
    make: "Mercury",
    name: "vehicle_make_mercury",
    label: "Vehicle Make Mercury",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Milan",
        value: "milan",
      },
      {
        label: "Mariner",
        value: "mariner",
      },
      {
        label: "Grand Marquis",
        value: "grand_marquis",
      },
      {
        label: "Mountaineer",
        value: "mountaineer",
      },
      {
        label: "Sable",
        value: "sable",
      },
      {
        label: "Montego",
        value: "montego",
      },
      {
        label: "Monterey",
        value: "monterey",
      },
      {
        label: "Marauder",
        value: "marauder",
      },
      {
        label: "Villager",
        value: "villager",
      },
      {
        label: "Cougar",
        value: "cougar",
      },
      {
        label: "Mystique",
        value: "mystique",
      },
      {
        label: "Tracer",
        value: "tracer",
      },
      {
        label: "Capri",
        value: "capri",
      },
      {
        label: "Topaz",
        value: "topaz",
      },
    ],
  },
  {
    make: "MINI",
    name: "vehicle_make_mini",
    label: "Vehicle Make MINI",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Countryman",
        value: "countryman",
      },
      {
        label: "Convertible",
        value: "convertible",
      },
      {
        label: "Hardtop 2 Door",
        value: "hardtop_2_door",
      },
      {
        label: "Hardtop 4 Door",
        value: "hardtop_4_door",
      },
      {
        label: "Clubman",
        value: "clubman",
      },
      {
        label: "Paceman",
        value: "paceman",
      },
      {
        label: "Coupe",
        value: "coupe",
      },
      {
        label: "Roadster",
        value: "roadster",
      },
      {
        label: "Hardtop",
        value: "hardtop",
      },
      {
        label: "Cooper",
        value: "cooper",
      },
    ],
  },
  {
    make: "Mitsubishi",
    name: "vehicle_make_mitsubishi",
    label: "Vehicle Make Mitsubishi",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Outlander Sport",
        value: "outlander_sport",
      },
      {
        label: "Eclipse Cross",
        value: "eclipse_cross",
      },
      {
        label: "Mirage G4",
        value: "mirage_g4",
      },
      {
        label: "Mirage",
        value: "mirage",
      },
      {
        label: "Outlander",
        value: "outlander",
      },
      {
        label: "Outlander PHEV",
        value: "outlander_phev",
      },
      {
        label: "Lancer",
        value: "lancer",
      },
      {
        label: "i-MiEV",
        value: "i_miev",
      },
      {
        label: "Lancer Evolution",
        value: "lancer_evolution",
      },
      {
        label: "Eclipse",
        value: "eclipse",
      },
      {
        label: "Galant",
        value: "galant",
      },
      {
        label: "Endeavor",
        value: "endeavor",
      },
      {
        label: "Raider Double Cab",
        value: "raider_double_cab",
      },
      {
        label: "Raider Extended Cab",
        value: "raider_extended_cab",
      },
      {
        label: "Montero",
        value: "montero",
      },
      {
        label: "Diamante",
        value: "diamante",
      },
      {
        label: "Montero Sport",
        value: "montero_sport",
      },
      {
        label: "3000GT",
        value: "3000gt",
      },
      {
        label: "Mighty Max Regular Cab",
        value: "mighty_max_regular_cab",
      },
      {
        label: "Expo",
        value: "expo",
      },
      {
        label: "Mighty Max Macro Cab",
        value: "mighty_max_macro_cab",
      },
      {
        label: "Precis",
        value: "precis",
      },
      {
        label: "Pajero",
        value: "pajero",
      },
    ],
  },
  {
    make: "Nissan",
    name: "vehicle_make_nissan",
    label: "Vehicle Make Nissan",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Armada",
        value: "armada",
      },
      {
        label: "Kicks",
        value: "kicks",
      },
      {
        label: "Murano",
        value: "murano",
      },
      {
        label: "NV3500 HD Passenger",
        value: "nv3500_hd_passenger",
      },
      {
        label: "NP200",
        value: "np200",
      },
      {
        label: "NV1500 Cargo",
        value: "nv1500_cargo",
      },
      {
        label: "Maxima",
        value: "maxima",
      },
      {
        label: "Magnite",
        value: "magnite",
      },
      {
        label: "370Z",
        value: "370z",
      },
      {
        label: "Altima",
        value: "altima",
      },
      {
        label: "GT-R",
        value: "gt_r",
      },
      {
        label: "NV3500 HD Cargo",
        value: "nv3500_hd_cargo",
      },
      {
        label: "Pathfinder",
        value: "pathfinder",
      },
      {
        label: "Patrol",
        value: "patrol",
      },
      {
        label: "Rogue",
        value: "rogue",
      },
      {
        label: "NV200",
        value: "nv200",
      },
      {
        label: "Rogue Sport",
        value: "rogue_sport",
      },
      {
        label: "NV2500 HD Cargo",
        value: "nv2500_hd_cargo",
      },
      {
        label: "Versa",
        value: "versa",
      },
      {
        label: "TITAN XD Crew Cab",
        value: "titan_xd_crew_cab",
      },
      {
        label: "Titan Crew Cab",
        value: "titan_crew_cab",
      },
      {
        label: "Frontier King Cab",
        value: "frontier_king_cab",
      },
      {
        label: "Frontier Crew Cab",
        value: "frontier_crew_cab",
      },
      {
        label: "LEAF",
        value: "leaf",
      },
      {
        label: "Sentra",
        value: "sentra",
      },
      {
        label: "TITAN Single Cab",
        value: "titan_single_cab",
      },
      {
        label: "NV200 Taxi",
        value: "nv200_taxi",
      },
      {
        label: "Titan King Cab",
        value: "titan_king_cab",
      },
      {
        label: "TITAN XD Single Cab",
        value: "titan_xd_single_cab",
      },
      {
        label: "Versa Note",
        value: "versa_note",
      },
      {
        label: "TITAN XD King Cab",
        value: "titan_xd_king_cab",
      },
      {
        label: "Quest",
        value: "quest",
      },
      {
        label: "JUKE",
        value: "juke",
      },
      {
        label: "Rogue Select",
        value: "rogue_select",
      },
      {
        label: "Xterra",
        value: "xterra",
      },
      {
        label: "cube",
        value: "cube",
      },
      {
        label: "350Z",
        value: "350z",
      },
      {
        label: "Pathfinder Armada",
        value: "pathfinder_armada",
      },
      {
        label: "Frontier Regular Cab",
        value: "frontier_regular_cab",
      },
      {
        label: "200SX",
        value: "200sx",
      },
      {
        label: "240SX",
        value: "240sx",
      },
      {
        label: "Regular Cab",
        value: "regular_cab",
      },
      {
        label: "King Cab",
        value: "king_cab",
      },
      {
        label: "300ZX",
        value: "300zx",
      },
      {
        label: "NX",
        value: "nx",
      },
      {
        label: "Stanza",
        value: "stanza",
      },
    ],
  },
  {
    make: "Oldsmobile",
    name: "vehicle_make_oldsmobile",
    label: "Vehicle Make Oldsmobile",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Bravada",
        value: "bravada",
      },
      {
        label: "Alero",
        value: "alero",
      },
      {
        label: "Silhouette",
        value: "silhouette",
      },
      {
        label: "Aurora",
        value: "aurora",
      },
      {
        label: "Intrigue",
        value: "intrigue",
      },
      {
        label: "Cutlass",
        value: "cutlass",
      },
      {
        label: "LSS",
        value: "lss",
      },
      {
        label: "88",
        value: "88",
      },
      {
        label: "Achieva",
        value: "achieva",
      },
      {
        label: "Regency",
        value: "regency",
      },
      {
        label: "Cutlass Supreme",
        value: "cutlass_supreme",
      },
      {
        label: "Ciera",
        value: "ciera",
      },
      {
        label: "98",
        value: "98",
      },
      {
        label: "Cutlass Ciera",
        value: "cutlass_ciera",
      },
      {
        label: "Cutlass Cruiser",
        value: "cutlass_cruiser",
      },
      {
        label: "Toronado",
        value: "toronado",
      },
      {
        label: "Custom Cruiser",
        value: "custom_cruiser",
      },
    ],
  },
  {
    make: "Opel",
    name: "vehicle_make_opel",
    label: "Vehicle Make Opel",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Astra",
        value: "astra",
      },
      {
        label: "Crossland",
        value: "crossland",
      },
      {
        label: "Corsa",
        value: "corsa",
      },
      {
        label: "Grandland",
        value: "grandland",
      },
      {
        label: "Mokka",
        value: "mokka",
      },
    ],
  },
  {
    make: "Panoz",
    name: "vehicle_make_panoz",
    label: "Vehicle Make Panoz",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Esperante",
        value: "esperante",
      },
    ],
  },
  {
    make: "Plymouth",
    name: "vehicle_make_plymouth",
    label: "Vehicle Make Plymouth",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Neon",
        value: "neon",
      },
      {
        label: "Grand Voyager",
        value: "grand_voyager",
      },
      {
        label: "Breeze",
        value: "breeze",
      },
      {
        label: "Voyager",
        value: "voyager",
      },
      {
        label: "Prowler",
        value: "prowler",
      },
      {
        label: "Acclaim",
        value: "acclaim",
      },
      {
        label: "Laser",
        value: "laser",
      },
      {
        label: "Colt",
        value: "colt",
      },
      {
        label: "Colt Vista",
        value: "colt_vista",
      },
      {
        label: "Sundance",
        value: "sundance",
      },
    ],
  },
  {
    make: "Polestar",
    name: "vehicle_make_polestar",
    label: "Vehicle Make Polestar",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "2",
        value: "2",
      },
    ],
  },
  {
    make: "Pontiac",
    name: "vehicle_make_pontiac",
    label: "Vehicle Make Pontiac",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Vibe",
        value: "vibe",
      },
      {
        label: "G6",
        value: "g6",
      },
      {
        label: "G3",
        value: "g3",
      },
      {
        label: "G6 (2009.5)",
        value: "g6_(2009.5)",
      },
      {
        label: "Solstice",
        value: "solstice",
      },
      {
        label: "G8",
        value: "g8",
      },
      {
        label: "Torrent",
        value: "torrent",
      },
      {
        label: "G5",
        value: "g5",
      },
      {
        label: "Grand Prix",
        value: "grand_prix",
      },
      {
        label: "GTO",
        value: "gto",
      },
      {
        label: "Montana SV6",
        value: "montana_sv6",
      },
      {
        label: "Bonneville",
        value: "bonneville",
      },
      {
        label: "Aztek",
        value: "aztek",
      },
      {
        label: "Grand Am",
        value: "grand_am",
      },
      {
        label: "Montana",
        value: "montana",
      },
      {
        label: "Sunfire",
        value: "sunfire",
      },
      {
        label: "Firebird",
        value: "firebird",
      },
      {
        label: "Trans Sport",
        value: "trans_sport",
      },
      {
        label: "Sunbird",
        value: "sunbird",
      },
      {
        label: "LeMans",
        value: "lemans",
      },
    ],
  },
  {
    make: "Porsche",
    name: "vehicle_make_porsche",
    label: "Vehicle Make Porsche",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Panamera",
        value: "panamera",
      },
      {
        label: "Taycan",
        value: "taycan",
      },
      {
        label: "911",
        value: "911",
      },
      {
        label: "Macan",
        value: "macan",
      },
      {
        label: "Cayenne Coupe",
        value: "cayenne_coupe",
      },
      {
        label: "Cayenne",
        value: "cayenne",
      },
      {
        label: "718 Boxster",
        value: "718_boxster",
      },
      {
        label: "718 Cayman",
        value: "718_cayman",
      },
      {
        label: "Cayman",
        value: "cayman",
      },
      {
        label: "Boxster",
        value: "boxster",
      },
      {
        label: "Carrera GT",
        value: "carrera_gt",
      },
      {
        label: "968",
        value: "968",
      },
      {
        label: "928",
        value: "928",
      },
      {
        label: "718 Spyder",
        value: "718_spyder",
      },
    ],
  },
  {
    make: "Ram",
    name: "vehicle_make_ram",
    label: "Vehicle Make Ram",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "3500 Crew Cab",
        value: "3500_crew_cab",
      },
      {
        label: "1500 Crew Cab",
        value: "1500_crew_cab",
      },
      {
        label: "2500 Crew Cab",
        value: "2500_crew_cab",
      },
      {
        label: "2500 Mega Cab",
        value: "2500_mega_cab",
      },
      {
        label: "1500 Classic Quad Cab",
        value: "1500_classic_quad_cab",
      },
      {
        label: "1500 Classic Crew Cab",
        value: "1500_classic_crew_cab",
      },
      {
        label: "1500 Classic Regular Cab",
        value: "1500_classic_regular_cab",
      },
      {
        label: "1500 Quad Cab",
        value: "1500_quad_cab",
      },
      {
        label: "2500 Regular Cab",
        value: "2500_regular_cab",
      },
      {
        label: "3500 Mega Cab",
        value: "3500_mega_cab",
      },
      {
        label: "ProMaster Cargo Van",
        value: "promaster_cargo_van",
      },
      {
        label: "ProMaster City",
        value: "promaster_city",
      },
      {
        label: "ProMaster Window Van",
        value: "promaster_window_van",
      },
      {
        label: "3500 Regular Cab",
        value: "3500_regular_cab",
      },
      {
        label: "1500 Regular Cab",
        value: "1500_regular_cab",
      },
      {
        label: "C/V Tradesman",
        value: "c/v_tradesman",
      },
      {
        label: "ProMaster 3500 Cargo",
        value: "promaster_3500_cargo",
      },
      {
        label: "ProMaster 2500 Cargo",
        value: "promaster_2500_cargo",
      },
      {
        label: "ProMaster 1500 Cargo",
        value: "promaster_1500_cargo",
      },
      {
        label: "C/V",
        value: "c/v",
      },
      {
        label: "Dakota Crew Cab",
        value: "dakota_crew_cab",
      },
      {
        label: "Dakota Extended Cab",
        value: "dakota_extended_cab",
      },
    ],
  },
  {
    make: "Renault",
    name: "vehicle_make_renault",
    label: "Vehicle Make Renault",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Captur",
        value: "captur",
      },
      {
        label: "Clio",
        value: "clio",
      },
      {
        label: "Duster",
        value: "duster",
      },
      {
        label: "Express Van",
        value: "express_van",
      },
      {
        label: "Kiger",
        value: "kiger",
      },
      {
        label: "Koleos",
        value: "koleos",
      },
      {
        label: "Kwid",
        value: "kwid",
      },
      {
        label: "Logan",
        value: "logan",
      },
      {
        label: "Megan",
        value: "megan",
      },
      {
        label: "Sandero",
        value: "sandero",
      },
      {
        label: "Trafic",
        value: "trafic",
      },
      {
        label: "Triber",
        value: "triber",
      },
    ],
  },
  {
    make: "Rivian",
    name: "vehicle_make_rivian",
    label: "Vehicle Make Rivian",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "R1S",
        value: "r1s",
      },
      {
        label: "R1T",
        value: "r1t",
      },
    ],
  },
  {
    make: "Rolls-Royce",
    name: "vehicle_make_rolls_royce",
    label: "Vehicle Make Rolls-Royce",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Ghost",
        value: "ghost",
      },
      {
        label: "Wraith",
        value: "wraith",
      },
      {
        label: "Dawn",
        value: "dawn",
      },
      {
        label: "Phantom",
        value: "phantom",
      },
    ],
  },
  {
    make: "Saab",
    name: "vehicle_make_saab",
    label: "Vehicle Make Saab",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "9-4X",
        value: "9_4x",
      },
      {
        label: "03-Sep",
        value: "03_sep",
      },
      {
        label: "05-Sep",
        value: "05_sep",
      },
      {
        label: "9-7X",
        value: "9_7x",
      },
      {
        label: "9-2X",
        value: "9_2x",
      },
      {
        label: "900",
        value: "900",
      },
      {
        label: "9000",
        value: "9000",
      },
    ],
  },
  {
    make: "Saturn",
    name: "vehicle_make_saturn",
    label: "Vehicle Make Saturn",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "VUE",
        value: "vue",
      },
      {
        label: "Outlook",
        value: "outlook",
      },
      {
        label: "Aura",
        value: "aura",
      },
      {
        label: "SKY",
        value: "sky",
      },
      {
        label: "Astra",
        value: "astra",
      },
      {
        label: "Relay",
        value: "relay",
      },
      {
        label: "Ion",
        value: "ion",
      },
      {
        label: "L-Series",
        value: "l_series",
      },
      {
        label: "S-Series",
        value: "s_series",
      },
    ],
  },
  {
    make: "Scion",
    name: "vehicle_make_scion",
    label: "Vehicle Make Scion",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "iA",
        value: "ia",
      },
      {
        label: "tC",
        value: "tc",
      },
      {
        label: "iM",
        value: "im",
      },
      {
        label: "FR-S",
        value: "fr_s",
      },
      {
        label: "iQ",
        value: "iq",
      },
      {
        label: "xB",
        value: "xb",
      },
      {
        label: "xD",
        value: "xd",
      },
      {
        label: "xA",
        value: "xa",
      },
    ],
  },
  {
    make: "smart",
    name: "vehicle_make_smart",
    label: "Vehicle Make smart",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "fortwo electric drive",
        value: "fortwo_electric_drive",
      },
      {
        label: "fortwo electric drive cabrio",
        value: "fortwo_electric_drive_cabrio",
      },
      {
        label: "fortwo cabrio",
        value: "fortwo_cabrio",
      },
      {
        label: "fortwo",
        value: "fortwo",
      },
    ],
  },
  {
    make: "SRT",
    name: "vehicle_make_srt",
    label: "Vehicle Make SRT",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Viper",
        value: "viper",
      },
    ],
  },
  {
    make: "Subaru",
    name: "vehicle_make_subaru",
    label: "Vehicle Make Subaru",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "BRZ",
        value: "brz",
      },
      {
        label: "WRX",
        value: "wrx",
      },
      {
        label: "Impreza",
        value: "impreza",
      },
      {
        label: "Ascent",
        value: "ascent",
      },
      {
        label: "Legacy",
        value: "legacy",
      },
      {
        label: "Crosstrek",
        value: "crosstrek",
      },
      {
        label: "Forester",
        value: "forester",
      },
      {
        label: "Outback",
        value: "outback",
      },
      {
        label: "XV Crosstrek",
        value: "xv_crosstrek",
      },
      {
        label: "Tribeca",
        value: "tribeca",
      },
      {
        label: "B9 Tribeca",
        value: "b9_tribeca",
      },
      {
        label: "Baja",
        value: "baja",
      },
      {
        label: "SVX",
        value: "svx",
      },
      {
        label: "Loyale",
        value: "loyale",
      },
      {
        label: "Justy",
        value: "justy",
      },
    ],
  },
  {
    make: "Suzuki",
    name: "vehicle_make_suzuki",
    label: "Vehicle Make Suzuki",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "SX4",
        value: "sx4",
      },
      {
        label: "Kizashi",
        value: "kizashi",
      },
      {
        label: "Grand Vitara",
        value: "grand_vitara",
      },
      {
        label: "Equator Extended Cab",
        value: "equator_extended_cab",
      },
      {
        label: "Equator Crew Cab",
        value: "equator_crew_cab",
      },
      {
        label: "XL7",
        value: "xl7",
      },
      {
        label: "Reno",
        value: "reno",
      },
      {
        label: "Forenza",
        value: "forenza",
      },
      {
        label: "Aerio",
        value: "aerio",
      },
      {
        label: "Brezza",
        value: "brezza",
      },
      {
        label: "XL-7",
        value: "xl_7",
      },
      {
        label: "Verona",
        value: "verona",
      },
      {
        label: "Vitara",
        value: "vitara",
      },
      {
        label: "Vitara Brezza",
        value: "vitara_brezza",
      },
      {
        label: "Esteem",
        value: "esteem",
      },
      {
        label: "Swift",
        value: "swift",
      },
      {
        label: "Sidekick",
        value: "sidekick",
      },
      {
        label: "Super Carry",
        value: "super_carry",
      },
      {
        label: "X-90",
        value: "x_90",
      },
      {
        label: "Samurai",
        value: "samurai",
      },
    ],
  },
  {
    make: "Tesla",
    name: "vehicle_make_tesla",
    label: "Vehicle Make Tesla",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Model X",
        value: "model_x",
      },
      {
        label: "Model 3",
        value: "model_3",
      },
      {
        label: "Model S",
        value: "model_s",
      },
    ],
  },
  {
    make: "Toyota",
    name: "vehicle_make_toyota",
    label: "Vehicle Make Toyota",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Agya",
        value: "agya",
      },
      {
        label: "Avalon",
        value: "avalon",
      },
      {
        label: "Avensis",
        value: "avensis",
      },
      {
        label: "Camry",
        value: "camry",
      },
      {
        label: "Corolla Hatchback",
        value: "corolla_hatchback",
      },
      {
        label: "Corolla",
        value: "corolla",
      },
      {
        label: "86",
        value: "86",
      },
      {
        label: "Fortuner",
        value: "fortuner",
      },
      {
        label: "Prado",
        value: "prado",
      },
      {
        label: "Avalon Hybrid",
        value: "avalon_hybrid",
      },
      {
        label: "4Runner",
        value: "4runner",
      },
      {
        label: "C-HR",
        value: "c_hr",
      },
      {
        label: "Camry Hybrid",
        value: "camry_hybrid",
      },
      {
        label: "Corolla Hybrid",
        value: "corolla_hybrid",
      },
      {
        label: "GR Supra",
        value: "gr_supra",
      },
      {
        label: "Highlander",
        value: "highlander",
      },
      {
        label: "Prius",
        value: "prius",
      },
      {
        label: "Prius Prime",
        value: "prius_prime",
      },
      {
        label: "RAV4",
        value: "rav4",
      },
      {
        label: "Tacoma Access Cab",
        value: "tacoma_access_cab",
      },
      {
        label: "Sienna",
        value: "sienna",
      },
      {
        label: "Starlet",
        value: "starlet",
      },
      {
        label: "Land Cruiser",
        value: "land_cruiser",
      },
      {
        label: "Urban Cruiser",
        value: "urban_cruiser",
      },
      {
        label: "Etios",
        value: "etios",
      },
      {
        label: "Yaris",
        value: "yaris",
      },
      {
        label: "RAV4 Hybrid",
        value: "rav4_hybrid",
      },
      {
        label: "Highlander Hybrid",
        value: "highlander_hybrid",
      },
      {
        label: "Sequoia",
        value: "sequoia",
      },
      {
        label: "Tundra Double Cab",
        value: "tundra_double_cab",
      },
      {
        label: "Tacoma Double Cab",
        value: "tacoma_double_cab",
      },
      {
        label: "Tundra CrewMax",
        value: "tundra_crewmax",
      },
      {
        label: "Yaris Hatchback",
        value: "yaris_hatchback",
      },
      {
        label: "Mirai",
        value: "mirai",
      },
      {
        label: "Prius c",
        value: "prius_c",
      },
      {
        label: "Corolla iM",
        value: "corolla_im",
      },
      {
        label: "Yaris iA",
        value: "yaris_ia",
      },
      {
        label: "Prius v",
        value: "prius_v",
      },
      {
        label: "Tundra Regular Cab",
        value: "tundra_regular_cab",
      },
      {
        label: "Prius Plug-in Hybrid",
        value: "prius_plug_in_hybrid",
      },
      {
        label: "Venza",
        value: "venza",
      },
      {
        label: "FJ Cruiser",
        value: "fj_cruiser",
      },
      {
        label: "Tacoma Regular Cab",
        value: "tacoma_regular_cab",
      },
      {
        label: "Matrix",
        value: "matrix",
      },
      {
        label: "Solara",
        value: "solara",
      },
      {
        label: "Tundra Access Cab",
        value: "tundra_access_cab",
      },
      {
        label: "Celica",
        value: "celica",
      },
      {
        label: "Echo",
        value: "echo",
      },
      {
        label: "MR2",
        value: "mr2",
      },
      {
        label: "Tacoma Xtracab",
        value: "tacoma_xtracab",
      },
      {
        label: "Supra",
        value: "supra",
      },
      {
        label: "T100 Regular Cab",
        value: "t100_regular_cab",
      },
      {
        label: "T100 Xtracab",
        value: "t100_xtracab",
      },
      {
        label: "Tercel",
        value: "tercel",
      },
      {
        label: "Paseo",
        value: "paseo",
      },
      {
        label: "Previa",
        value: "previa",
      },
      {
        label: "Regular Cab",
        value: "regular_cab",
      },
      {
        label: "Xtra Cab",
        value: "xtra_cab",
      },
      {
        label: "Cressida",
        value: "cressida",
      },
      {
        label: "RAV4 Prime",
        value: "rav4_prime",
      },
    ],
  },
  {
    make: "Volkswagen",
    name: "vehicle_make_volkswagen",
    label: "Vehicle Make Volkswagen",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "Passat",
        value: "passat",
      },
      {
        label: "Polo",
        value: "polo",
      },
      {
        label: "Polo Vivo",
        value: "polo_vivo",
      },
      {
        label: "Tiguan",
        value: "tiguan",
      },
      {
        label: "Jetta",
        value: "jetta",
      },
      {
        label: "Atlas",
        value: "atlas",
      },
      {
        label: "Golf SportWagen",
        value: "golf_sportwagen",
      },
      {
        label: "Arteon",
        value: "arteon",
      },
      {
        label: "e-Golf",
        value: "e_golf",
      },
      {
        label: "Golf",
        value: "golf",
      },
      {
        label: "Golf GTI",
        value: "golf_gti",
      },
      {
        label: "Jetta GLI",
        value: "jetta_gli",
      },
      {
        label: "Beetle",
        value: "beetle",
      },
      {
        label: "Golf Alltrack",
        value: "golf_alltrack",
      },
      {
        label: "Golf R",
        value: "golf_r",
      },
      {
        label: "Tiguan Limited",
        value: "tiguan_limited",
      },
      {
        label: "CC",
        value: "cc",
      },
      {
        label: "Touareg",
        value: "touareg",
      },
      {
        label: "T-Cross",
        value: "t_cross",
      },
      {
        label: "T-Roc",
        value: "t_roc",
      },
      {
        label: "Eos",
        value: "eos",
      },
      {
        label: "GTI",
        value: "gti",
      },
      {
        label: "Routan",
        value: "routan",
      },
      {
        label: "Jetta SportWagen",
        value: "jetta_sportwagen",
      },
      {
        label: "New Beetle",
        value: "new_beetle",
      },
      {
        label: "Rabbit",
        value: "rabbit",
      },
      {
        label: "Touareg 2",
        value: "touareg_2",
      },
      {
        label: "GLI",
        value: "gli",
      },
      {
        label: "R32",
        value: "r32",
      },
      {
        label: "Phaeton",
        value: "phaeton",
      },
      {
        label: "Jetta (New)",
        value: "jetta_(new)",
      },
      {
        label: "Eurovan",
        value: "eurovan",
      },
      {
        label: "Cabrio",
        value: "cabrio",
      },
      {
        label: "Caravelle",
        value: "caravelle",
      },
      {
        label: "California",
        value: "california",
      },
      {
        label: "Passat (New)",
        value: "passat_(new)",
      },
      {
        label: "Cabrio (New)",
        value: "cabrio_(new)",
      },
      {
        label: "Golf (New)",
        value: "golf_(new)",
      },
      {
        label: "GTI (New)",
        value: "gti_(new)",
      },
      {
        label: "Golf III",
        value: "golf_iii",
      },
      {
        label: "Jetta III",
        value: "jetta_iii",
      },
      {
        label: "Corrado",
        value: "corrado",
      },
      {
        label: "Cabriolet",
        value: "cabriolet",
      },
      {
        label: "Fox",
        value: "fox",
      },
      {
        label: "Atlas Cross Sport",
        value: "atlas_cross_sport",
      },
    ],
  },
  {
    make: "Volvo",
    name: "vehicle_make_volvo",
    label: "Vehicle Make Volvo",
    description: "Car model and make",
    groupName: "enrolment_information",
    type: "enumeration",
    fieldType: "select",
    formField: "true",
    displayOrder: 6,
    options: [
      {
        label: "XC40",
        value: "xc40",
      },
      {
        label: "XC60",
        value: "xc60",
      },
      {
        label: "XC90",
        value: "xc90",
      },
      {
        label: "S60",
        value: "s60",
      },
      {
        label: "V60",
        value: "v60",
      },
      {
        label: "V90",
        value: "v90",
      },
      {
        label: "S90",
        value: "s90",
      },
      {
        label: "S80",
        value: "s80",
      },
      {
        label: "XC70",
        value: "xc70",
      },
      {
        label: "C30",
        value: "c30",
      },
      {
        label: "C70",
        value: "c70",
      },
      {
        label: "V50",
        value: "v50",
      },
      {
        label: "S40",
        value: "s40",
      },
      {
        label: "V70",
        value: "v70",
      },
      {
        label: "S40 (New)",
        value: "s40_(new)",
      },
      {
        label: "V40",
        value: "v40",
      },
      {
        label: "S70",
        value: "s70",
      },
      {
        label: "850",
        value: "850",
      },
      {
        label: "960",
        value: "960",
      },
      {
        label: "940",
        value: "940",
      },
      {
        label: "240",
        value: "240",
      },
      {
        label: "740",
        value: "740",
      },
    ],
  },
];

export default models;
